import React from 'react';
import { Task } from '../../types';

type Props = {
  show: boolean;
  task: Task | null;
  onClose: () => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
};

export default function EditTaskModal({ show, task, onClose, onSubmit }: Props) {
  if (!show || !task) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-2xl w-full">
        <form onSubmit={onSubmit} className="p-6 space-y-4">
          <h2 className="text-2xl font-bold text-gray-900">Editar Tarefa</h2>
          <input name="title" required defaultValue={task.title} className="w-full p-2 border rounded" />
          <textarea name="description" defaultValue={task.description || ''} className="w-full p-2 border rounded"></textarea>
          <div className="grid grid-cols-3 gap-4">
            <select name="status" defaultValue={task.status} className="w-full p-2 border rounded">
              <option>Pendente</option>
              <option>Em Andamento</option>
              <option>Concluída</option>
            </select>
            <select name="priority" defaultValue={task.priority} className="w-full p-2 border rounded">
              <option>Baixa</option>
              <option>Média</option>
              <option>Alta</option>
            </select>
            <input name="assignee" defaultValue={task.assignee || ''} className="w-full p-2 border rounded" />
          </div>
          <input name="due_date" type="date" defaultValue={task.due_date || ''} className="w-full p-2 border rounded" />
          <div className="flex justify-end space-x-4">
            <button type="button" onClick={onClose} className="px-6 py-2 border rounded">Cancelar</button>
            <button type="submit" className="px-6 py-2 bg-indigo-600 text-white rounded">Salvar</button>
          </div>
        </form>
      </div>
    </div>
  );
}